<div class="main about-us-page" *ngIf="orderDetails">
    <div class="container">
        <div class="white-bg">
            <h1 class="or">Order Receipt</h1>
            <br />
            <div class="row">
                <div class="col-lg-12">
                    <h2 class="bg-success">{{orderDetails?.outletName}}</h2>
                    <div class="order-recipt-wrap">
                        <div class="order-recipt-box">
                            <div class="customername">
                                <strong>Customer Name :</strong>
                                {{orderDetails?.billing?.isGuestUser ?
                                orderDetails?.billing?.guestUser?.name :
                                orderDetails?.user?.name}}
                            </div>
                            <div class="customername">
                                <strong>Email :</strong>
                                {{orderDetails?.billing?.isGuestUser ?
                                orderDetails?.billing?.guestUser?.email :
                                orderDetails?.user?.email}}
                            </div>
                            <div class="customername">
                                <strong>Mobile :</strong>
                                {{orderDetails?.billing?.isGuestUser ?
                                orderDetails?.billing?.guestUser?.mobile :
                                orderDetails?.user?.mobile}}
                            </div>
                            <div class="customername"
                                *ngIf="orderDetails?.billing?.deliveryType === deliveryType.Delivery">
                                <strong>Address :</strong>
                                {{orderDetails?.billing?.address?.address}}
                            </div>
                        </div>

                        <div class="order-recipt-box">
                            <div class="customername">
                                <strong>
                                    {{orderDetails?.billing?.deliveryType === deliveryType.Delivery ?
                                    'Delivery' : 'Pickup'}}
                                </strong>
                                <span *ngIf="orderDetails?.billing?.isScheduleOrder">
                                    {{orderDetails?.billing?.scheduledOrderDate |
                                    date:'shortDate'}} {{orderDetails?.billing?.scheduledOrderTime}}
                                </span>
                                <span *ngIf="!orderDetails?.billing?.isScheduleOrder">
                                    {{orderDetails?.expectedOrderTime | date:'short'}}
                                </span>
                            </div>
                            <div class="customername">
                                <strong>Payment Status:</strong>
                                {{orderDetails?.billing?.paymentType === paymentType.Cash ? 'Unpaid' : 'Paid'}}
                            </div>
                            <div class="customername">
                                <strong>Total Amount:</strong>
                                ${{orderDetails?.billing?.totalAmount | number : '1.2-2'}}
                            </div>
                        </div>
                    </div>
                    <div class="cart-content-wrap" *ngIf="orderDetails?.billing?.isAdvancePickup">
                        <strong>Pickup Type: </strong> {{orderDetails?.billing?.isAdvancePickup ? '(' +
                        orderDetails?.billing?.advancePickup?.title +
                        ')' : ''}}
                        <div class="cart-content"
                            *ngIf="orderDetails?.billing?.advancePickup?.advancePickupDetails?.length > 0">
                            <div class="cart-content-row"
                                *ngFor="let item of orderDetails?.billing?.advancePickup?.advancePickupDetails">
                                <div class="cart-content-item"><strong>{{item?.question}}: </strong> {{item?.answer}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cart-content-wrap">
                        <div class="cart-content" role="table" aria-label="Receipt items">
                            <div class="cart-content-row" role="row">
                                <div class="cart-content-item" role="columnheader"><strong>Description</strong> </div>
                                <div class="cart-content-item" role="columnheader"><strong>Qty</strong> </div>
                                <div class="cart-content-item" role="columnheader"><strong>Unit Price($)</strong> </div>
                                <div class="cart-content-item" role="columnheader"><strong>Amount($)</strong>
                                </div>
                            </div>

                            <div class="cart-content-row1" role="rowgroup">
                                <div class="cart-content-row" role="row" *ngFor="let item of orderDetails?.menuItems">
                                    <div class="cart-content-item" role="cell">
                                        <span style="font-weight: bold; font-size:20px;">{{item?.itemName}}</span>
                                        <div *ngIf="item?.menuAddons?.length > 0">
                                            <div *ngFor="let group of item?.menuAddons">
                                                <strong>{{group?.groupName}}</strong>
                                                <br />
                                                <span *ngFor="let addOn of group?.menuAddonItems"
                                                    style="font-family: Gotham, 'Gotham Black', 'Gotham Thin';font-size: 14px; color: #555;">
                                                    {{addOn?.name}}
                                                    (${{addOn?.price}})
                                                    <br />
                                                </span>
                                                <br />
                                            </div>
                                        </div>
                                        <strong><span *ngIf="item?.note != ''">Note: {{item?.note}}</span></strong>
                                    </div>
                                    <div class="cart-content-item" role="cell">{{item?.quantity}}</div>
                                    <div class="cart-content-item" role="cell"> ${{item?.unitPrice | number : '1.2-2'}}</div>
                                    <div class="cart-content-item" role="cell"> ${{item?.unitPrice * item?.quantity | number :
                                        '1.2-2'}}</div>
                                </div>

                                <div *ngIf="orderDetails?.billing?.specialInstructions != ''" class="cart-content-row" role="row">
                                    <div class="cart-content-item" role="cell" style="width: 100%;">
                                        <strong>Order Note:</strong> {{orderDetails?.billing?.specialInstructions}}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <h2 class="bg-success"> Payment Summary</h2>
                    <div class="cart-content-wrap">

                        <div class="paymentsummary">
                            <div class="cart-content-item"><strong>Order Id:</strong>
                                <span>{{orderDetails?.billing?.orderId}}</span>
                            </div>
                            <div class="cart-content-item"><strong>Order Total:</strong>
                                <span>${{orderDetails?.billing?.cartAmount | number : '1.2-2'}}</span>
                            </div>
                            <div class="cart-content-item"> <strong>Coupon Discount:</strong>
                                <span>${{orderDetails?.billing?.couponDiscount | number : '1.2-2'}} </span>
                            </div>
                            <div class="cart-content-item"> <strong>Reward Discount:</strong>
                                <span>${{orderDetails?.billing?.rewardsDiscount | number : '1.2-2'}}</span>
                            </div>
                            <div class="cart-content-item"> <strong>After Discount Total:</strong>
                                <span>${{orderDetails?.billing?.discountedAmount | number : '1.2-2'}}</span>
                            </div>
                            <div class="cart-content-item" *ngFor="let item of orderDetails?.billing?.taxes">
                                <strong> {{item?.name}}:</strong>
                                <span>${{item?.amount | number : '1.2-2'}} </span>
                            </div>
                            <div class="cart-content-item" *ngFor="let item of orderDetails?.billing?.fees">
                                <strong> {{item?.name}}:</strong>
                                <span>${{item?.amount | number : '1.2-2'}} </span>
                            </div>
                            <div class="cart-content-item"><strong>Delivery Charges:</strong>
                                <span>${{orderDetails?.billing?.deliveryCharges | number : '1.2-2'}}</span>
                            </div>

                            <div class="cart-content-item"> <strong>Tip Amount:</strong>
                                <span>${{orderDetails?.billing?.tipAmount | number : '1.2-2'}}</span>
                            </div>
                            <div class="cart-content-item" *ngIf="orderDetails?.billing?.isVoucherApplied"><strong>Gift Card Amount:</strong>
                                <span>-${{orderDetails?.billing?.voucher?.amount | number : '1.2-2'}}</span>
                            </div>
                            <div class="cart-content-item"> <strong> Total Amount:</strong>
                                <span>${{orderDetails?.billing?.totalAmount | number : '1.2-2'}}</span>
                            </div>
                        </div>

                    </div>
                    <h2 class="bg-success"> Thank you</h2>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="error-page-wrap" *ngIf="!orderDetails">
    <div class="main about-us-page">
        <div class="container">
            <div class="white-bg">
                <div class="content-box container error-page">
                    <h1>Order Details Not Found...</h1>
                    <div>
                        <div class="text-center"><i class="fa fa-5x fa-frown-o" aria-hidden="true"></i></div>
                        <h2 class="h3 text-center">Sorry!</h2>
                        <p class="desc darker">You are trying to fetch the old order. Please check it on admin panel
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>